// extracted by mini-css-extract-plugin
export default {"container":"Xk-z","bubbleNav":"Yk-z","graphic":"Zk-z","contact":"_k-z"};